var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppStatusTrackerDotEmpty = function SvgAppStatusTrackerDotEmpty(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "17px",
    height: "17px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -620 -92 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 628.5 92  C 633.26 92  637 95.74  637 100.5  C 637 105.26  633.26 109  628.5 109  C 623.74 109  620 105.26  620 100.5  C 620 95.74  623.74 92  628.5 92  Z ",
    fillRule: "nonzero",
    fill: "#d1cfcf",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 628.5 92.5  C 632.98 92.5  636.5 96.02  636.5 100.5  C 636.5 104.98  632.98 108.5  628.5 108.5  C 624.02 108.5  620.5 104.98  620.5 100.5  C 620.5 96.02  624.02 92.5  628.5 92.5  Z ",
    strokeWidth: 1,
    stroke: "#d1cfcf",
    fill: "none"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppStatusTrackerDotEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/app_status_tracker_dot_empty.c73d43dec0c4eeaef6b3a990cb553dfe.svg";